import { Location } from '@angular/common';
import { AfterViewInit, Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { LocalizationService } from 'app/core/localization/localization.service';
import { DataTrackLabelEnum } from 'app/shared/enums/data-track-label.enum';
import { NewsItem } from 'app/shared/models/news-widget/news-item-model';
import { KhAnalyticsService } from 'app/shared/services/kh-analytics.service';

@Component({
  selector: 'kh-news-article-teacher-modal',
  templateUrl: './news-article-modal-teacher.component.html',
  styleUrl: './news-article-modal-teacher.component.less',
  standalone: false
})
export class NewsArticleTeacherModalComponent implements AfterViewInit {
  private readonly router = inject(Router);
  private readonly bsModalRef = inject(BsModalRef);
  private readonly localizationService = inject(LocalizationService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly location = inject(Location);
  private readonly analytics = inject(KhAnalyticsService);

  public data!: NewsItem;
  public callBack?: () => void;
  public isTransientUser = false;

  public closeModal(): void {
    this.bsModalRef.hide();
  }

  public transformDescription(html: string): SafeHtml {
    const transformed = html.replace(/<br\s*\/?>/gi, '<div style="height:2rem;"></div>');
    return this.sanitizer.bypassSecurityTrustHtml(transformed);
  }

  public goto() {
    this.analytics.trackEvent({
      eventType: DataTrackLabelEnum.TeacherHyperlinkBttnClicked,
      jsonData: {
        articleId: this.data.id,
        subject: this.data.subject
      }
    });
    if (this.data.hyperlink) {
      location.href = this.data.hyperlink;
    }
  }

  public ngAfterViewInit(): void {
    this.callBack?.();
  }
}
